module.exports = __webpack_public_path__ + "static/img/zh-Hans.e7a5baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/pc/zh-Hans.png
// module id = FArs
// module chunks = 1